import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-maskedinput';
import CurrencyInput from 'react-currency-input';
import ReactCSSTransitionReplace from 'react-css-transition-replace';
import classNames from 'classnames';
import './index.css';

const propTypes = {
  label: PropTypes.element,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mask: PropTypes.string,
  placeholder: PropTypes.string,
  format: PropTypes.func,
  currency: PropTypes.bool,
  icon: PropTypes.element,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  isValid: PropTypes.bool,
  isInvalid: PropTypes.bool,
  errorMsg: PropTypes.string,
  isCentered: PropTypes.bool,
  noBorder: PropTypes.bool,
  noBorderRadius: PropTypes.bool,
};

const defaultProps = {
  label: null,
  onClick: null,
  onFocus: null,
  onBlur: null,
  value: '',
  mask: null,
  placeholder: null,
  format: null,
  currency: false,
  icon: null,
  required: false,
  disabled: false,
  isValid: null,
  isInvalid: null,
  isCentered: false,
  errorMsg: null,
  noBorder: false,
  noBorderRadius: false,
};

const currencyPrefix = 'R$';

class TextField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFocused: false,
      value: props.value || '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value !== this.state.value) {
      this.changeInputValue(value);
    }
  }

  onChange = event => {
    const {
      target: { value },
    } = event;

    this.changeInputValue(value);
  };

  changeInputValue = value => {
    const { onChange, format } = this.props;
    let val = value;

    if (format) {
      val = format(val);
    }

    if (onChange) {
      onChange(val);
    }

    this.setState({ value: val });
  };

  onFocus = event => {
    const { onFocus } = this.props;

    this.setState({ isFocused: true });

    if (onFocus) {
      onFocus(event);
    }
  };

  onBlur = event => {
    const { onBlur } = this.props;

    this.setState({ isFocused: false });

    if (onBlur) {
      onBlur(event);
    }
  };

  get inputId() {
    return `${this.props.name}-text-field`;
  }

  renderInput = () => {
    const {
      mask,
      currency,
      name,
      placeholder,
      disabled,
      onClick,
      required,
      isCentered,
    } = this.props;
    const { value } = this.state;
    const commonProps = {
      className: classNames('TextField__input', { 'TextField__input--centered': isCentered }),
      id: this.inputId,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onClick,
      name,
      value,
      placeholder,
      disabled,
      required,
    };

    if (mask) {
      return <MaskedInput {...commonProps} mask={mask} onChange={this.onChange} />;
    }

    if (currency) {
      return (
        <CurrencyInput
          {...commonProps}
          decimalSeparator=","
          thousandSeparator="."
          prefix={currencyPrefix}
          onChange={this.changeInputValue}
        />
      );
    }

    return <input {...commonProps} type="text" onChange={this.onChange} />;
  };

  renderErrorMsg = () => {
    const { errorMsg, isInvalid, disabled } = this.props;

    if (errorMsg && isInvalid && !disabled) {
      return (
        <div key="error" className="TextField__errorMsg">
          {errorMsg}
        </div>
      );
    }

    return null;
  };

  get inputClassModifiers() {
    const { disabled, icon, label, isInvalid, isValid, noBorder, noBorderRadius } = this.props;

    return {
      'is-disabled': disabled,
      'is-invalid': isInvalid,
      'is-valid': isValid,
      'TextField--icon': !!icon,
      'TextField--no_label': !label,
      'TextField--no_border': noBorder,
      'TextField--no_border_radius': noBorderRadius,
    };
  }

  render() {
    const { label, icon } = this.props;

    return (
      <div className={classNames('TextField', this.inputClassModifiers)}>
        {label && (
          <label className="TextField__label" htmlFor={this.inputId}>
            {label}
          </label>
        )}
        <div className="TextField__input_wrapper">
          {icon && <div className="TextField__icon">{icon}</div>}
          {this.renderInput()}
        </div>
        <ReactCSSTransitionReplace
          transitionName="TextField-fade-height"
          transitionEnterTimeout={350}
          transitionLeaveTimeout={250}
        >
          {this.renderErrorMsg()}
        </ReactCSSTransitionReplace>
      </div>
    );
  }
}

TextField.propTypes = propTypes;
TextField.defaultProps = defaultProps;

export default TextField;



// WEBPACK FOOTER //
// ../ui-components/components/TextField/index.jsx